export const VENDOR_MANAGER = 'vendorManager'

export const vendor_manager = {
  en: {
    translation: {
      [VENDOR_MANAGER]: {
        markets: 'Markets',
        stateName: 'State',
        newMarket: 'New Market',
        modifiedDateSubmit: 'Modified Date',
        metroServiceArea: 'Metropolitan Service Area',
        abbreviation: 'Abbreviation',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        cancel: 'Cancel',
        save: 'Save',
        newVendor: 'New Vendor',

        //Vendor Skills
        vendorSkills: 'Vendor Trades',
        newVendorSkills: 'New Vendor Trade',
        skills: 'Trades',
        modifiedDate: 'Modified Date',

        //Markets
        state: 'State',
        lienDue: 'Lien Due',

        //Cards
        active: 'Active',
        inActive: 'InActive',
        doNotUse: 'Do Not Use',
        expired: 'Expired',
        licensed: 'Licensed',
      },
    },
  },
  es: {
    translation: {
      [VENDOR_MANAGER]: {
        licensed: 'Con licencia',
        markets: 'Mercados',
        stateName: 'Nombre del Estado',
        newMarket: 'Nuevo mercado',
        metroServiceArea: 'Área de servicio metropolitano',
        abbreviation: 'Abreviatura',
        modifiedDateSubmit: 'Fecha de modificación',
        createdBy: 'Creado por',
        createdDate: 'Fecha de creación',
        modifiedBy: 'Modificado Por',
        cancel: 'Cancelar',
        save: 'Ahorrar',
        newVendor: 'Nuevo vendedor',
        //Vendor Skills
        vendorSkills: 'Habilidades del proveedor',
        newVendorSkills: 'Habilidades de nuevos proveedores',
        skills: 'Habilidades',
        modifiedDate: 'Fecha de modificación',

        //Market
        state: 'Estado',

        //Cards
        active: 'Activo',
        inActive: 'En Activo',
        doNotUse: 'No Utilice',
        expired: 'Caducado',
      },
    },
  },
}
